import { NameSpace } from '../../../constants/NameSpace';

type TShouldShowMediaTypesSelectForNamespace = (namespace: NameSpace) => boolean;
export const shouldShowMediaTypesSelectForNamespace: TShouldShowMediaTypesSelectForNamespace = (namespace) => {
  switch (namespace) {
    case NameSpace.WixMusic:
    case NameSpace.WixVideo:
    case NameSpace.ArtStore:
    case NameSpace.All:
      return false;
    case NameSpace.DigitalProduct:
    default:
      return true;
  }
};
